import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://topclassimoveis.com";

/**
 * Keeps <link rel="canonical"> in sync with the current route on every navigation.
 * Listing detail pages may override the canonical with their own resolved slug URL.
 */
const CanonicalUpdater = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const href = `${SITE_ORIGIN}${pathname}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);

    let ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute("content", href);
  }, [pathname]);

  return null;
};

export default CanonicalUpdater;
